import {request} from '../jslib/request'

// 查询用户列表
export function commonreq(query,url) {
    return request({
        url: url,
        data: query
    })
}